module.exports = __webpack_public_path__ + "static/a1-7a75158e622bbd9cdadaffbfee6327d2.png";